import { useState, useEffect } from 'react';
import type { FederatedRoute } from './AppContent.types';

export const useFederatedRoutes = () => {
  const [routes, setRoutes] = useState<FederatedRoute[]>([]);
  const [routesLoading, setRoutesLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadRoutesConfig = async () => {
      setRoutesLoading(true);
      let data = null;
      
      const isLocal = typeof window !== 'undefined' && 
        (window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' || 
         window.location.hostname.endsWith('.bfme.dev') || 
         window.location.hostname.endsWith('.local'));

      if (isLocal) {
        try {
          const response = await fetch('/federatedRoutes.local.json');
          if (response.ok) {
            data = await response.json();
          }
        } catch {
          // ignore error to fallback
        }
      }

      if (!data) {
        try {
          const response = await fetch('/federatedRoutes.json');
          if (response.ok) {
            data = await response.json();
          }
        } catch (e) {
          console.error('Failed to load federatedRoutes.json:', e);
        }
      }

      if (active && data) {
        // Resolve relative script/css URLs against current window.location.origin to prevent CORS & MIME errors
        const resolved = data.map((route: FederatedRoute) => ({
          ...route,
          scriptUrl: route.scriptUrl?.startsWith('/')
            ? `${window.location.origin}${route.scriptUrl}`
            : route.scriptUrl,
          cssUrl: route.cssUrl?.startsWith('/')
            ? `${window.location.origin}${route.cssUrl}`
            : route.cssUrl,
        }));
        (window as any).federatedRoutes = resolved;
        setRoutes(resolved);
      }
      if (active) {
        setRoutesLoading(false);
      }
    };

    loadRoutesConfig();

    return () => {
      active = false;
    };
  }, []);

  return { routes, routesLoading };
};
